export default "__VITE_ASSET__BhAlLUuZ__"